import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

function getAdminAuthConfig() {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

/**
 * Get creators
 */
export async function getCreatorsApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append("page", payload.page || 1);
    fd.append("limit", payload.limit || 10);
    fd.append("search", payload.search || "");
    fd.append(
      "designation",
      payload.designation || ""
    );
    fd.append(
      "business",
      payload.business || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/creators/list`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Creators Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Creators fetch failed",
    };
  }
}

/**
 * Get creator stats
 */
export async function getCreatorStatsApi() {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/creators/stats`,
      {},
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Creator Stats Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Creator stats fetch failed",
    };
  }
}

/**
 * Get single creator
 */
export async function getCreatorApi(creatorId) {
  try {
    const fd = new FormData();

    fd.append(
      "creator_id",
      creatorId || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/creators/view`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Creator Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Creator fetch failed",
    };
  }
}

/**
 * Create creator
 */
export async function createCreatorApi(payload = {}) {
  try {
    const fd = new FormData();


    fd.append(
      "cre_username",
      payload.cre_username || ""
    );

    fd.append(
      "cre_buss_name",
      payload.cre_buss_name || ""
    );

    fd.append(
      "cre_designation",
      payload.cre_designation || ""
    );

    fd.append(
      "cre_profile_pic",
      payload.cre_profile_pic || ""
    );

    fd.append(
      "cre_exprience",
      payload.cre_exprience || ""
    );

    fd.append(
      "cre_short_comment",
      payload.cre_short_comment || ""
    );

    fd.append(
      "cre_following",
      payload.cre_following || ""
    );

    fd.append(
      "cre_reach",
      payload.cre_reach || ""
    );

    fd.append(
      "cre_channels",
      payload.cre_channels || ""
    );

    fd.append(
      "cre_tags",
      payload.cre_tags || ""
    );

    // fd.append(
    //   "created_by",
    //   payload.created_by || ""
    // );

    const adminData = JSON.parse(
      sessionStorage.getItem("ldata") || "{}"
    );

    fd.append(
      "created_by",
      adminData.id || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/creators/create`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Create Creator Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Creator creation failed",
    };
  }
}

/**
 * Update creator
 */
export async function updateCreatorApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append(
      "creator_id",
      payload.creator_id || ""
    );

    fd.append(
      "cre_username",
      payload.cre_username || ""
    );

    fd.append(
      "cre_buss_name",
      payload.cre_buss_name || ""
    );

    fd.append(
      "cre_designation",
      payload.cre_designation || ""
    );

    fd.append(
      "cre_profile_pic",
      payload.cre_profile_pic || ""
    );

    fd.append(
      "cre_exprience",
      payload.cre_exprience || ""
    );

    fd.append(
      "cre_short_comment",
      payload.cre_short_comment || ""
    );

    fd.append(
      "cre_following",
      payload.cre_following || ""
    );

    fd.append(
      "cre_reach",
      payload.cre_reach || ""
    );

    fd.append(
      "cre_channels",
      payload.cre_channels || ""
    );

    fd.append(
      "cre_tags",
      payload.cre_tags || ""
    );

    fd.append(
      "created_by",
      payload.created_by || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/creators/update`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Update Creator Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Creator update failed",
    };
  }
}

/**
 * Delete creator
 */
export async function deleteCreatorApi(creatorId) {
  try {
    const fd = new FormData();

    fd.append(
      "creator_id",
      creatorId || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/creators/delete`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Delete Creator Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Creator deletion failed",
    };
  }
}